import { inject, NgModule } from '@angular/core';
import { CanActivateFn, Router, RouterModule, Routes } from '@angular/router';
import { AgendaComponent } from './components/agenda/agenda.component';
import { CreateActivityComponent } from './components/create-activity/create-activity.component';
import { ListActivityParticipantsFinanceComponent } from './components/list-activity-participants-finance/list-activity-participants-finance.component';
import { ActivityParticipantsComponent } from './components/agenda/single-activity/activity-participants.component';
import { CreateActivityInviteComponent } from './components/create-activity-invite/create-activity-invite.component';
import { AgendaActivitesComponent } from './components/agenda-activites/agenda-activites.component';

// ===== DÉBUT AJOUT : les apprenants ont leur propre agenda =====
const PROFILS_AGENDA_APPRENANT = [1]; // 1 = apprenant

const redirigerVersAgendaApprenant: CanActivateFn = () => {
  const user = JSON.parse(sessionStorage.getItem('user') ?? '{}');
  return PROFILS_AGENDA_APPRENANT.includes(Number(user?.profile?.id))
    ? inject(Router).createUrlTree(['/dashboard/agenda/apprenant'])
    : true;
};
// ===== FIN AJOUT =====
const routes: Routes = [
  {
    path: '',
    component: AgendaComponent,
    canActivate: [redirigerVersAgendaApprenant], // ← AJOUT
  },
  {
    path: 'create-activity',
    component: CreateActivityComponent,
    canActivate: [redirigerVersAgendaApprenant], // ← AJOUT (facultatif, même raison)
  },
  {
    path: 'edit-activity/:id',
    component: CreateActivityComponent,
    canActivate: [redirigerVersAgendaApprenant],
  },
  {
    path: 'participants/:id',
    component: ListActivityParticipantsFinanceComponent,
  },
  // ===== MODIF : même composant, l'espace est passé dans « data » =====
  {
    path: 'gestionnaire',
    component: AgendaActivitesComponent,
    data: { espace: 'gestionnaire' },
  },
  {
    path: 'apprenant',
    component: AgendaActivitesComponent,
    data: { espace: 'apprenant' },
  },
  // ===== FIN MODIF =====
  {
    path: 'activity-details/:id',
    component: ActivityParticipantsComponent,
  },
  {
    path: 'create-activity-invite',
    component: CreateActivityInviteComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgendaRoutingModule {}
